import axios from '../../axios';

const login = async ({ userData, formikHelpers }) => {
  try {
    const { data } = await axios.post('/auth/login', {...userData});
    return data;
  } catch (e) {
    throw e;
  }
}

const emailLink = async ({user_id, action}) => {
  console.log(user_id, action, "email link");
  try {
    const result = await axios.post(`/auth/email-link/${user_id}?action=${action}`);
    return result.data;
  } catch (e) {
    throw e;
  }
}

const activateAccount = async ({user_id, action}) => {
  try {
    await axios.post(`/auth/activate-account/${user_id}?action=${action}`);
    return {action};
  } catch (e) {
    throw e;
  }
}

const logOutUser = async (user_id) => {
  try {
    const result = await axios.post(`/auth/logout-account/${user_id}`);
    return result.data;
  } catch (e) {
    throw e;
  }
}

const getMe = async () => {
  try {
      const { data } = await axios.get('/auth/me');
      return data;
  } catch (error) {
     return null;
  }
};

const logout = async () => {
  await axios.post('/auth/logout')
}

export default {
  login,
  getMe,
  logout,
  emailLink,
  activateAccount,
  logOutUser
};
